import { Loading } from '@iheartjane/reefer';
import { Action } from '@thoughtspot/visual-embed-sdk';
import {
  LiveboardEmbed,
  useEmbedRef,
} from '@thoughtspot/visual-embed-sdk/react';
import { useContext } from 'react';

import { AnalyticsPageContext } from '@jane/business-admin/providers';

type AnalyticsRoutes =
  | 'kpis'
  | 'sales'
  | 'customers'
  | 'fulfillment'
  | 'inventory-forecasts'
  | 'on-menu-merchandising'
  | 'off-menu-advertising'
  | 'off-menu-merchandising'
  | 'jane-gold'
  | 'google-traffic'
  | 'web-traffic'
  | 'marketing-attribution'
  | 'printers'
  | 'product-reviews'
  | 'store-reviews'
  | 'trends'
  | 'pricing'
  | 'marketplace'
  | 'sdk';

type Names =
  | 'KPIs'
  | 'Sales'
  | 'Customers'
  | 'Fulfillment'
  | 'Inventory Forecasts'
  | 'On-Menu Merchandising'
  | 'Off-Menu Advertising'
  | 'Off-Menu Merchandising for non-Jane Ecomm'
  | 'Jane Gold'
  | 'Google Traffic'
  | 'Web Traffic'
  | 'Marketing Attribution'
  | 'Product Reviews'
  | 'Store Reviews'
  | 'Trends'
  | 'Pricing'
  | 'Printers'
  | 'Marketplace'
  | 'SDK';

const routeToLiveBoardName: Record<AnalyticsRoutes, Names> = {
  kpis: 'KPIs',
  sales: 'Sales',
  customers: 'Customers',
  fulfillment: 'Fulfillment',
  'inventory-forecasts': 'Inventory Forecasts',
  'on-menu-merchandising': 'On-Menu Merchandising',
  'off-menu-advertising': 'Off-Menu Advertising',
  'off-menu-merchandising': 'Off-Menu Merchandising for non-Jane Ecomm',
  'jane-gold': 'Jane Gold',
  'google-traffic': 'Google Traffic',
  'web-traffic': 'Web Traffic',
  'marketing-attribution': 'Marketing Attribution',
  'product-reviews': 'Product Reviews',
  'store-reviews': 'Store Reviews',
  trends: 'Trends',
  pricing: 'Pricing',
  printers: 'Printers',
  marketplace: 'Marketplace',
  sdk: 'SDK',
} as const;

export const Liveboard = ({ liveboardRoute }: { liveboardRoute: string }) => {
  const embedRef = useEmbedRef<typeof LiveboardEmbed>();
  const analyticsContext = useContext(AnalyticsPageContext);

  const nameInFocus =
    routeToLiveBoardName[liveboardRoute as keyof typeof routeToLiveBoardName];

  const relevantSubPayload = Object.values(
    analyticsContext.authorizedLiveboards
  )
    .flat()
    .find((obj) => obj?.name === nameInFocus);

  const liveboardId = relevantSubPayload?.id;

  const visibleActions = [
    Action.Download,
    Action.DownloadAsPdf,
    Action.DownloadAsPng,
    Action.DownloadAsCsv,
    Action.DownloadAsXlsx,
    Action.AxisMenuFilter,
  ];

  if (analyticsContext.isAuthenticating)
    return <Loading size="lg" color="black" />;

  if (!liveboardId || analyticsContext.authState === undefined) return null;

  return (
    <LiveboardEmbed
      visibleActions={visibleActions}
      liveboardId={liveboardId}
      ref={embedRef}
      frameParams={{
        height: 'calc(100vh - 80px)',
        width: '100%',
      }}
    />
  );
};
